













import {Component, Prop, Vue} from 'vue-property-decorator';
import SolutionItem from '@/views/solution/components/solutionItem.vue';
import CollapseBox from '@/components/collapseBox/collapseBox.vue';
import { classifyDataByKey, generateClassifications, ICollapseInfo, mergeClassifiedData } from '@/components/collapseBox/collapseBoxUtils';
import { AccountModule } from '@/store/modules/account';

type ISolutionInfo = ISolution.IResponse.ISolutionInfo;

@Component({
  components: {
    SolutionItem,
    CollapseBox,
  },
})
export default class SolutionList extends Vue {
  @Prop({default: ''}) private activeId!: string;
  @Prop({default: false}) private spinning!: boolean;
  @Prop({required: true, default: () => []}) private data!: ISolutionInfo[];
  private viewDetail(solution: ISolutionInfo) {
    this.$emit('click', solution);
  }
  get classifyDataByAccount() {
    // 根据账号对应的projects 生成 分类数据
    return generateClassifications(AccountModule.projects, 'id', 'name');
  }
  get dataByProjectCategory(): ICollapseInfo[] {
    const classifyData = classifyDataByKey(this.data, 'projectId', 'projectName');
    return mergeClassifiedData(this.classifyDataByAccount, classifyData);
  }
}
